import { Tooltip } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { useMemo } from 'react';
import IconFont from '@ys/repo-ui/base/IconFont';
import * as style from './index.css';

const CreditsTooltip = ({ position }: { position: string}) => {
  const t = useI18n();

  const tooltipContent = useMemo(
    () => (
      <div className={style.creditsContentItemTitleInfo}>
        <div className={style.creditsContentItemTitleInfoTitle}>
          <div className={style.creditsContentItemTitleInfoTitleLeft}>
            {t['com.muset.credits.detail.card.item.credit.info.title']()}
          </div>
          <div
            className={style.creditsContentItemTitleInfoTitleRight}
            onClick={() => {
              window.open(`${window.location.origin}/credits-help`, '_blank');
            }}
          >
            {t['com.muset.credits.detail.card.item.credit.info.title.more']()}
          </div>
        </div>
        <div className={style.creditsContentItemTitleInfoContent}>
          <div className={style.creditsContentItemTitleInfoContentleft}>·</div>
          <div className={style.creditsContentItemTitleInfoContentRight}>
            {t[
              'com.muset.credits.detail.card.item.credit.info.description-1'
            ]()}
          </div>
        </div>
        <div className={style.creditsContentItemTitleInfoContent}>
          <div className={style.creditsContentItemTitleInfoContentleft}>·</div>
          <div className={style.creditsContentItemTitleInfoContentRight}>
            {t[
              'com.muset.credits.detail.card.item.credit.info.description-2'
            ]()}
          </div>
        </div>
        <div className={style.creditsContentItemTitleInfoContent}>
          <div className={style.creditsContentItemTitleInfoContentleft}>·</div>
          <div className={style.creditsContentItemTitleInfoContentRight}>
            {t[
              'com.muset.credits.detail.card.item.credit.info.description-3'
            ]()}
          </div>
        </div>
        <div className={style.creditsContentItemTitleInfoContent}>
          <div className={style.creditsContentItemTitleInfoContentleft}>·</div>
          <div className={style.creditsContentItemTitleInfoContentRight}>
            {t[
              'com.muset.credits.detail.card.item.credit.info.description-4'
            ]()}
          </div>
        </div>
      </div>
    ),
    [t]
  );

  return (
    <Tooltip
      side={position === 'settingDialog' ? 'bottom' : 'top'}
      content={tooltipContent}
      options={
        {className: style.tooltipContent}
      }
    >
      <IconFont
        className={style.creditsContentItemTitleTextRight}
        name="question-circle"
        size={16}
      />
    </Tooltip>        
  );
};
export default CreditsTooltip;
